var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStatus = function SvgStatus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "status_svg2__a",
    x1: -3.29,
    x2: 199.82,
    y1: 193.99,
    y2: 9.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M6.34 35.32h95.07c2.87 13.04 14.51 22.83 28.4 22.83s25.54-9.79 28.4-22.83h35.45c3.45 0 6.24-2.8 6.24-6.24s-2.8-6.24-6.24-6.24h-35.45C155.34 9.8 143.68.01 129.81.01s-25.53 9.8-28.4 22.83H6.34C2.89 22.83.1 25.63.1 29.08s2.8 6.24 6.24 6.24m106.88-6.23v-.07c.03-9.12 7.47-16.54 16.59-16.54S146.36 19.89 146.4 29v.09c-.01 9.13-7.45 16.56-16.59 16.56s-16.57-7.42-16.59-16.55v-.02Zm80.44 135.59h-35.45c-2.87-13.03-14.53-22.83-28.4-22.83s-25.53 9.8-28.4 22.83H6.34c-3.45 0-6.24 2.8-6.24 6.24s2.8 6.24 6.24 6.24h95.07c2.87 13.04 14.51 22.83 28.4 22.83s25.54-9.79 28.4-22.83h35.45c3.45 0 6.24-2.8 6.24-6.24s-2.8-6.24-6.24-6.24m-63.85 22.83c-9.13 0-16.57-7.42-16.59-16.55v-.09c.03-9.12 7.47-16.54 16.59-16.54s16.55 7.41 16.59 16.52v.09c-.01 9.14-7.45 16.56-16.59 16.56Zm63.85-93.75H98.59c-2.87-13.04-14.51-22.83-28.4-22.83s-25.54 9.79-28.4 22.83H6.34C2.89 93.76.1 96.56.1 100s2.8 6.24 6.24 6.24h35.45c2.87 13.03 14.53 22.83 28.4 22.83s25.53-9.8 28.4-22.83h95.07c3.45 0 6.24-2.8 6.24-6.24s-2.8-6.24-6.24-6.24M86.78 99.98v.07c-.03 9.12-7.47 16.54-16.59 16.54s-16.55-7.41-16.59-16.52v-.09c.01-9.14 7.45-16.56 16.59-16.56s16.57 7.42 16.59 16.55v.02Z",
    style: {
      fill: "url(#status_svg2__a)",
      strokeWidth: 0
    }
  }));
};
export default SvgStatus;